import { Column, Table } from '@tanstack/react-table';
import moment from 'moment';
import React from 'react';
import Form from 'react-bootstrap/Form';
import DateRangePickerWithChildren from '../common/DateRangePickerWithChildren';

export default function DateRangeFilter({
  column,
  table,
  initialSettings
}: {
  column: Column<any, unknown>
  table: Table<any>,
  initialSettings: { [key: string]: any }
}) {
  const columnFilterValue = column.getFilterValue() as { startDate?: string; endDate?: string } | undefined;
  const displayValue = columnFilterValue?.startDate && columnFilterValue?.endDate
    ? `${columnFilterValue.startDate} - ${columnFilterValue.endDate}`
    : '';

  const settings = {
    autoUpdateInput: false,
    locale: {
      cancelLabel: 'Clear',
      applyLabel: 'Apply',
      format: 'YYYY/MM/DD'
    },
    ranges: {
      'Today': [moment().startOf('day'), moment().endOf('day')],
      'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
      'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
      'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    },
    ...initialSettings
  };

  return (
    <div>
      <DateRangePickerWithChildren
        initialSettings={settings}
        onCallback={(startDate, endDate, label) => {
          if (label === 'Clear' || !startDate || !endDate) {
            column.setFilterValue(undefined);
          } else {
            column.setFilterValue({
              startDate: moment(startDate).format('YYYY/MM/DD'),
              endDate: moment(endDate).format('YYYY/MM/DD'),
            });
          }
        }}>
        <Form.Control
          type="text"
          size="sm"
          readOnly
          value={displayValue}
          placeholder="Select date range"
          onClick={(e) => {
            e.preventDefault();
          }}
          style={{ cursor: 'pointer' }} />
      </DateRangePickerWithChildren>
    </div>
  );
};
